import { forwardRef } from 'react';
import { useSearchParams } from 'react-router-dom';

import useLocale from 'hooks/useLocale';
import { useNavigateSearch } from 'hooks/useNavigateSearch';

import * as S from './MoreConnection.styled';

const Card = ({ data }, ref) => {
	const navigateSearch = useNavigateSearch();
	const [searchParams] = useSearchParams();
	const { LanguageCode } = useLocale();

	const img = data.icon ?? data.logo;

	return (
		<S.ImgContainer
			ref={ref}
			onClick={() => {
				navigateSearch('/shipping-partners/shipping-partner-form', {
					mode: 'add',
					id: data.ID,
					img,
					name: LanguageCode === 'arabicValue' ? (data.nameAR ?? data.name) : data.name,
					integrationName: data.integrationName,
					...(searchParams.has('oto-token') && { otoMobile: true })
				});
			}}>
			<S.StandartPartnerImage url={img} width="11.5rem" height="11.5rem" />
		</S.ImgContainer>
	);
};

Card.displayName = 'Card';

export default forwardRef(Card);
